/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentVersionDetails extends models.AwsSsmDocumentVersion {
    getFixupPrototypeFunction() { return AwsSsmDocumentVersionDetails.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentVersionDetails>): AwsSsmDocumentVersionDetails {
        let obj = Object.assign(new AwsSsmDocumentVersionDetails(), model);
        AwsSsmDocumentVersionDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentVersionDetails>): AwsSsmDocumentVersionDetails {
        if (!model) return null;
        return AwsSsmDocumentVersionDetails.newInstance(<AwsSsmDocumentVersionDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentVersionDetails) {
        if (!obj) return;

        models.AwsSsmDocumentVersionDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentVersionDetails): boolean {
        if (models.AwsSsmDocumentVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentVersionDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.document_creation_time === "string") {
            this.document_creation_time = new Date(<string><any>this.document_creation_time);
        }
    }

    sysId: string;

    document_creation_time: Date;

}
